import {Component, ViewChild} from '@angular/core';
import {MatDialog}            from '@angular/material/dialog';
import {MatPaginator}         from '@angular/material/paginator';
import {MatSnackBar}          from '@angular/material/snack-bar';
import {MatTableDataSource}   from '@angular/material/table';
import {ApiService}           from '@src/app/shared/services/api.service';
import {WalkthroughService}   from '@src/app/shared/services/walkthrough/walkthrough.service';
import {query}                from 'js-query-builder';
import Swal                   from 'sweetalert2';
import {RolesService}         from '../../services/roles.service';

@Component({
    selector: 'app-roles',
    templateUrl: './roles.component.html',
    styleUrls: ['./roles.component.css']
})
export class RolesComponent
{
    // roles: any[] = [];

    @ViewChild(MatPaginator) public paginator!: MatPaginator;
    public displayedColumns: string[] = ['name', 'permissions_count', 'user_count', 'actions'];

    public default_roles: MatTableDataSource<any> = new MatTableDataSource();
    public default_roles_total_rows = 0;
    public default_roles_page_size = 50;
    public default_roles_current_page = 0;

    public custom_roles: MatTableDataSource<any> = new MatTableDataSource();
    public custom_roles_total_rows = 0;
    public custom_roles_page_size = 50;
    public custom_roles_current_page = 0;
    public pageSizeOptions: number[] = [5, 10, 25, 100];

    constructor(
        public walkthroughService: WalkthroughService,
        private apiService: ApiService,
        private dialog: MatDialog,
        private roleService: RolesService,
        private snackbar: MatSnackBar
    )
    {
        // const default_url = query('roles').filter('guard_name', 'api').filter('author_id', 0).build();
        const default_url = query('roles')
            .filter('guard_name', 'api')
            .filter('author_id', 0)
            .build();

        this.apiService.queryList(default_url, this.default_roles_current_page + 1, this.default_roles_page_size)
            .subscribe(
                response => {
                    this.default_roles = response.data;
                    this.default_roles.paginator.pageIndex = this.default_roles_current_page;
                    this.default_roles.paginator.length = response.meta.total;
                    this.default_roles.paginator = this.paginator;
                },
                error => {
                    this.apiService.handleError(error);
                }
            );

        const custom_url = query('roles')
            .filter('guard_name', 'api')
            .filter('author_id-gt', 0)
            .build();

        this.apiService.queryList(custom_url, this.custom_roles_current_page + 1, this.custom_roles_page_size)
            .subscribe(
                response => {
                    this.custom_roles = response.data;
                    this.custom_roles.paginator.pageIndex = this.custom_roles_current_page;
                    this.custom_roles.paginator.length = response.meta.total;
                    this.custom_roles.paginator = this.paginator;
                },
                error => {
                    this.apiService.handleError(error);
                }
            );

        this.walkthroughService.start('settings.roles', false);
    }

    public editRole(role = null)
    {
        this.roleService.editRole(role);
    }

    public createRole()
    {
        this.roleService.editRole({create: true});
    }

    public onDelete(role_id)
    {
        Swal.fire({
            title: 'Are you sure want to delete this role?',
            icon: 'warning',
            iconColor: '#ff9030',
            background: '#424242',
            customClass: {
                title: 'sweetAlertTitle'
            },
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No, keep it'
        }).then((result) => {
            if (result.value) {
                this.apiService.delete('roles', role_id).subscribe(
                    response => {
                        this.snackbar.open('Role archived.', 'Ok.', {duration: 2500});
                        const custom_url = query('roles').filter('guard_name', 'api').filter('author_id-gt', 0).build();
                        this.apiService.queryList(custom_url, this.custom_roles_current_page + 1, this.custom_roles_page_size).subscribe(
                            response => {
                                this.custom_roles = response.data;
                                this.paginator.pageIndex = this.custom_roles_current_page;
                                this.paginator.length = response.meta.total;
                                this.custom_roles.paginator = this.paginator;
                            },
                            error => {
                                this.apiService.handleError(error);
                            });
                    },
                    error => {
                        this.snackbar.open('Error deleting role', 'Ok', {duration: 5000});
                    }
                );
            }
        });
    }

}
